import { FavoriteList, UpdateFavoriteListCommand, 
    CreateFavoriteListCommand, 
    AddItemToFavoriteListCommand,
    RemoveItemFromFavoriteListCommand, DeleteFavoriteListCommand, FavoriteListViewModel, FavoriteListItemViewModel, GetAllFavoriteListDetailsRequest, RemoveItemFromAllFavoriteListsCommand} from "Api/CoreApi"
    import { defineModule } from "direct-vuex";
    import store, { moduleActionContext, moduleGetterContext } from "."
    import ApiServices from "Api/ApiFactory";
import ApiFactory from "Api/ApiFactory";
import ProductListHelper from "Helpers/ProductListHelper";
    
    
    
    // export interface FavoriteItemWithListDetails{
    //     favoritelistid: number;
    //     favoritelistItemId: number;
    //     sortOrder?: number;
    //     note?: string | undefined;
    //     itemId?: number;
    //     favoriteListId?: number;
    //     name?: string | undefined;
    // }
    
    

    export interface ProductlistWithFavoriteList{
        productkey: string;
        favoriteListIds: number[];
    }
    
    export interface IFavoriteListsState {
        currentProductKey : string;
        favoriteListMenuShow: boolean;
        productsMap: Map<string, ProductlistWithFavoriteList>;
        favoriteLists: FavoriteListViewModel[];
        detectChanges: boolean;
        isLoading: boolean;
        error: boolean;        
    }
    
    const initialFavoriteList: IFavoriteListsState = {
        currentProductKey: null,
        favoriteListMenuShow: false,
        productsMap: null,
        favoriteLists: null,
        error: false,
        isLoading: false,
        //hack to trigger re-rendering of component - just use it in a getter and flip it
        detectChanges: null
    }
    
    //TODO: mso - change whole implementatoin
    let promise: Promise<any>;
    const favoriteList = defineModule({
        namespaced: true,
        state: (): IFavoriteListsState => {
            return initialFavoriteList;
        },
        getters: {
            productMapToFavoriteLists(...args: any): Map<string, ProductlistWithFavoriteList> {
                const { state, getters, rootState, rootGetters } = mod1GetterContext(args);
                return state.productsMap;            
            }
        },
        mutations: {
            SET_FAVORITELISTS(state, favoriteLists: FavoriteList[]) {
                //TODO: mso - use detail lists instead - to avoid load of all lists from server
                //TODO: mso - get list by productkeys 
                state.favoriteLists = favoriteLists;
                const dic = new Map<string, ProductlistWithFavoriteList>();
                let obj;
                for(let list of favoriteLists)
                {
                    for(let item of list.items)
                    {
                        let obj: ProductlistWithFavoriteList;
                        if(!dic.has(item.productKey))
                        {
                            dic.set(item.productKey, obj = <ProductlistWithFavoriteList>{});
                            obj.favoriteListIds = new Array<number>();
                        }
                        else{
                            obj = dic.get(item.productKey);
                        }
                        
                        obj.favoriteListIds.push(list.id);
                    }
                }
                
                state.productsMap = dic;
            },
            SET_FAVORITELISTDETAILS(state, favoriteLists: FavoriteListViewModel[])
            {
                state.favoriteLists = favoriteLists;
            },
            ADD_FAVORITELIST(state, payload: {newId: number, favoriteList: CreateFavoriteListCommand}) {
                
                const newObj = new FavoriteListViewModel({
                    id: payload.newId,
                    name: payload.favoriteList.name,
                    itemsCount: 0
                });

                state.favoriteLists.push(newObj);
            },
            DELETE_FAVORITELIST(state, favoriteListId:number) {
                state.favoriteLists = state.favoriteLists.filter(x => x.id !== favoriteListId);
            },
            
            SET_FAVORITELISTNAME(state, update: UpdateFavoriteListCommand) {
                let list = state.favoriteLists.find(x => x.id == update.id);
                list.name = update.name;
            },
            TOGGLE_FAVORITELIST_MENU(state) {
                state.favoriteListMenuShow = !state.favoriteListMenuShow;
            },
            SET_CURRENT_PRODUCT(state, productKey: string) {
                state.currentProductKey = productKey;
            },
            DELETE_ITEM(state, remove: RemoveItemFromFavoriteListCommand) {
                
                if(state.productsMap.has(remove.productKey))
                {
                    var favoritelists = state.productsMap.get(remove.productKey).favoriteListIds;
                    state.productsMap.get(remove.productKey).favoriteListIds = favoritelists.filter(x => x != remove.favoriteListId);
                }
                state.detectChanges = !state.detectChanges;
                //else do nothing??..
            },
            DELETE_All_ITEMS(state, remove: RemoveItemFromAllFavoriteListsCommand) {
                
                if(state.productsMap.has(remove.productKey))
                {
                    state.productsMap.delete(remove.productKey);
                }
                state.detectChanges = !state.detectChanges;
                //else do nothing??..
            },
            ADD_FAVORITELIST_ITEM(state, obj: AddItemToFavoriteListCommand){
                if(state.productsMap.has(obj.productKey))
                {
                    state.productsMap.get(obj.productKey).favoriteListIds.push(obj.favoriteListId);
                }
                else{
                    var newObj = <ProductlistWithFavoriteList>{};
                    newObj.favoriteListIds = new Array<number>();
                    newObj.favoriteListIds.push(obj.favoriteListId);
                    state.productsMap.set(obj.productKey,newObj)
                }
                state.detectChanges = !state.detectChanges;
            }
        },
        actions: {
            //TODO: get list by productkeys from the DOM - look for class and inner join the productkeys - the function is made!
            async loadFavoriteLists(context, force: boolean) : Promise<any> {
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                //console.log('before promise');
                if(force) promise = null;

                return promise || (promise = new Promise(async (resolve, reject) => {
                    let productKeys = await ProductListHelper.GetAllProductKeys();
                    //console.log(productKeys);
                    let client = await ApiFactory.getFavoriteListClient();
                    let response = await client.getAll(productKeys);
                    commit.SET_FAVORITELISTS(response.favoriteLists);
                    resolve();
                }));
            },
            async loadFavoriteListDetails(context) : Promise<any> {
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                // console.log('before promise');
                let client = await ApiFactory.getFavoriteListClient();
                let response = await client.getAllDetails(new GetAllFavoriteListDetailsRequest());
                commit.SET_FAVORITELISTS(response.favoriteLists);
            },
            async updateFavoriteList(context, update: UpdateFavoriteListCommand) {
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                let client = await ApiFactory.getFavoriteListClient();
                await client.update(update);
                //TODO: add exception handling?
                commit.SET_FAVORITELISTNAME(update);
                state.detectChanges = !state.detectChanges;
            },
            async createFavoriteList(context, create: CreateFavoriteListCommand) {
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                let client = await ApiFactory.getFavoriteListClient();
                const response = await client.create(create);
                state.detectChanges = !state.detectChanges;
                commit.ADD_FAVORITELIST({newId : response.id, favoriteList: create });
                commit.ADD_FAVORITELIST_ITEM(new AddItemToFavoriteListCommand({
                    favoriteListId: response.id,
                    productKey : create.productKey
                }));
                
            },
            async deleteFavoriteList(context, del: DeleteFavoriteListCommand) {
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                let client = await ApiFactory.getFavoriteListClient();
                await client.delete(del);
                commit.DELETE_FAVORITELIST(del.id);
            },
            async addItemOnFavoriteList(context,addItem: AddItemToFavoriteListCommand){
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                let client = await ApiFactory.getFavoriteListClient();
                await client.addItem(addItem);
                commit.ADD_FAVORITELIST_ITEM(addItem);
                //TODO: make controller return new Item and use mutation instead
                // await dispatch.loadFavoriteLists();
            },
            async removeItemOnFavoriteList(context, removeItem: RemoveItemFromFavoriteListCommand){
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                let client = await ApiFactory.getFavoriteListClient();
                await client.removeItem(removeItem);
                commit.DELETE_ITEM(removeItem);
            },
            async removeAllItemsFromFavoriteLists(context, removeItem: RemoveItemFromAllFavoriteListsCommand){
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                let client = await ApiFactory.getFavoriteListClient();
                await client.removeAllItems(removeItem);
                commit.DELETE_All_ITEMS(removeItem);
            },
            async toggleFavoriteListMenu(context, payload: {productKey: string}){
                const { dispatch, commit, getters, state } = mod1ActionContext(context);
                commit.SET_CURRENT_PRODUCT(payload.productKey);
                commit.TOGGLE_FAVORITELIST_MENU();
            }
        }
    });
    
    export default favoriteList;
    const mod1GetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, favoriteList);
    const mod1ActionContext = (context: any) => moduleActionContext(context, favoriteList);
    